/**
 * Listes de domaines email pour la validation professionnelle
 * Phase 3 - Validation Email Professionnel
 */

// Domaines email personnels à bloquer
export const PERSONAL_EMAIL_DOMAINS = [
  // Grands fournisseurs internationaux
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'tutanota.com',
  'mail.com',
  'gmx.com',
  'yandex.com',
  'mail.ru',
  
  // Fournisseurs français
  'free.fr',
  'orange.fr',
  'wanadoo.fr',
  'sfr.fr',
  'neuf.fr',
  'club-internet.fr',
  'laposte.net',
  'voila.fr',
  'cegetel.net',
  'aliceadsl.fr',
  'numericable.fr',
  'bbox.fr',
  'dartybox.com',
  
  // Autres fournisseurs européens
  'web.de',
  'gmx.de',
  't-online.de',
  'freenet.de',
  'libero.it',
  'virgilio.it',
  'tiscali.it',
  'terra.es',
  'telefonica.net',
  'ono.com'
];

// Domaines email jetables/temporaires à bloquer
export const DISPOSABLE_EMAIL_DOMAINS = [
  // Services jetables populaires
  'mailinator.com',
  'guerrillamail.com',
  'temp-mail.org',
  'yopmail.com',
  '10minutemail.com',
  'throwaway.email',
  'maildrop.cc',
  'sharklasers.com',
  'trashmail.com',
  'tempmail.net',
  'getnada.com',
  'mohmal.com',
  'emailondeck.com',
  'fakeinbox.com',
  'spamgourmet.com',
  'mailcatch.com',
  'mailnesia.com',
  'tempinbox.com',
  'dispostable.com',
  'tempail.com',
  
  // Services avec sous-domaines
  'mailinator.net',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.biz',
  'guerrillamail.de',
  'spam4.me',
  'grr.la',
  'guerrillamailblock.com',
  
  // Autres services jetables
  'mytrashmail.com',
  'mailexpire.com',
  'rcpt.at',
  'trash-mail.at',
  'kurzepost.de',
  'objectmail.com',
  'proxymail.eu',
  'dodgeit.com',
  'spamex.com',
  'nowmymail.com',
  'mt2014.com',
  'thankyou2010.com',
  'guerrillamail.info'
];

// Domaines suspects (peuvent être légitimes mais souvent utilisés pour spam)
export const SUSPICIOUS_EMAIL_DOMAINS = [
  'mailbox.org',
  'cock.li',
  'aaathats3as.com',
  'abwesend.de',
  'anonymbox.com',
  'antichef.com',
  'antichef.net',
  'antispam.de',
  'binkmail.com',
  'bio-muesli.net',
  'bobmail.info',
  'brennendesreich.de',
  'cool.fr.nf',
  'correo.blogos.net',
  'cosmorph.com',
  'courriel.fr.nf',
  'courrieltemporaire.com',
  'curryworld.de',
  'dacoolest.com',
  'dandikmail.com',
  'dayrep.com',
  'dcemail.com',
  'deadaddress.com',
  'despammed.com',
  'devnullmail.com',
  'dfgh.net',
  'digitalsanctuary.com',
  'discardmail.com',
  'discardmail.de',
  'disposableaddress.com',
  'disposableemailaddresses.com',
  'disposableinbox.com',
  'dispose.it',
  'dispostable.com',
  'dm.de',
  'dodgeit.com',
  'dodgit.com',
  'donemail.ru',
  'dontreg.com',
  'dontsendmespam.de',
  'drdrb.net',
  'dump-email.info',
  'dumpandjunk.com',
  'dumpyemail.com',
  'e4ward.com',
  'email60.com',
  'emailias.com',
  'emailinfive.com',
  'emailmiser.com',
  'emailsensei.com',
  'emailtemporanea.com',
  'emailtemporanea.net',
  'emailtemporar.ro',
  'emailtemporario.com.br',
  'emailthe.net',
  'emailtmp.com',
  'emailto.de',
  'emailwarden.com',
  'emailx.at.hm',
  'emailxfer.com',
  'emz.net',
  'enterto.com',
  'ephemail.net',
  'etranquil.com',
  'etranquil.net',
  'etranquil.org',
  'evopo.com',
  'explodemail.com',
  'express.net.ua',
  'eyepaste.com',
  'fakeinformation.com',
  'fakemailz.com',
  'fakeoutdoorsman.com',
  'fastacura.com',
  'fastchevy.com',
  'fastchrysler.com',
  'fastkawasaki.com',
  'fastmazda.com',
  'fastmitsubishi.com',
  'fastnissan.com',
  'fastsubaru.com',
  'fastsuzuki.com',
  'fasttoyota.com',
  'fastyamaha.com',
  'filzmail.com',
  'fizmail.com',
  'fleckens.hu',
  'flyspam.com',
  'footard.com',
  'forgetmail.com',
  'fr33mail.info',
  'frapmail.com',
  'freeanonymousemail.com',
  'freemeil.ga',
  'freeml.net',
  'freemium.de',
  'freundin.ru',
  'fux0ringduh.com',
  'garliclife.com',
  'get.pp.ua',
  'get1mail.com',
  'get2mail.fr',
  'getairmail.com',
  'getmails.eu',
  'getonemail.com',
  'getonemail.net',
  'ghosttexter.de',
  'girlsundertheinfluence.com',
  'gishpuppy.com',
  'great-host.in',
  'greensloth.com',
  'grr.la',
  'gsrv.co.uk',
  'guerillamail.biz',
  'guerillamail.com',
  'guerillamail.de',
  'guerillamail.net',
  'guerillamail.org',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.info',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamailblock.com',
  'gustr.com',
  'harakirimail.com',
  'hatespam.org',
  'hidemail.de',
  'hidzz.com',
  'hmamail.com',
  'hopemail.biz',
  'hotpop.com',
  'hulapla.de',
  'ieatspam.eu',
  'ieatspam.info',
  'ieh-mail.de',
  'ikbenspamvrij.nl',
  'imails.info',
  'inboxalias.com',
  'inboxclean.com',
  'inboxclean.org',
  'incognitomail.com',
  'incognitomail.net',
  'incognitomail.org',
  'insorg-mail.info',
  'instant-mail.de',
  'ip6.li',
  'irish2me.com',
  'iwi.net',
  'jetable.com',
  'jetable.fr.nf',
  'jetable.net',
  'jetable.org',
  'jnxjn.com',
  'jourrapide.com',
  'jsrsolutions.com',
  'junk1e.com',
  'kaspop.com',
  'keepmymail.com',
  'killmail.com',
  'killmail.net',
  'kir.ch.tc',
  'klassmaster.com',
  'klzlk.com',
  'kook.ml',
  'koszmail.pl',
  'kurzepost.de',
  'l33r.eu',
  'lackmail.net',
  'lags.us',
  'landmail.co',
  'lastmail.co',
  'lavabit.com',
  'letthemeatspam.com',
  'lhsdv.com',
  'lifebyfood.com',
  'link2mail.net',
  'litedrop.com',
  'lol.ovpn.to',
  'lolfreak.net',
  'lookugly.com',
  'lopl.co.cc',
  'lortemail.dk',
  'lr78.com',
  'lroid.com',
  'lukop.dk',
  'm21.cc',
  'mail-filter.com',
  'mail-temporaire.fr',
  'mail.by',
  'mail.mezimages.net',
  'mail2rss.org',
  'mail333.com',
  'mail4trash.com',
  'mailbidon.com',
  'mailbiz.biz',
  'mailblocks.com',
  'mailbucket.org',
  'mailcat.biz',
  'mailcatch.com',
  'mailde.de',
  'mailde.info',
  'maildrop.cc',
  'maildrop.cf',
  'maildrop.ga',
  'maildrop.gq',
  'maildrop.ml',
  'maileater.com',
  'mailed.ro',
  'mailexpire.com',
  'mailfa.tk',
  'mailforspam.com',
  'mailfreeonline.com',
  'mailguard.me',
  'mailimate.com',
  'mailin8r.com',
  'mailinater.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'mailinator2.com',
  'mailincubator.com',
  'mailismagic.com',
  'mailme.lv',
  'mailme24.com',
  'mailmetrash.com',
  'mailmoat.com',
  'mailms.com',
  'mailnator.com',
  'mailnesia.com',
  'mailnull.com',
  'mailorg.org',
  'mailpick.biz',
  'mailrock.biz',
  'mailscrap.com',
  'mailshell.com',
  'mailsiphon.com',
  'mailtemp.info',
  'mailtome.de',
  'mailtothis.com',
  'mailtrash.net',
  'mailtv.net',
  'mailtv.tv',
  'mailzilla.com',
  'mailzilla.org',
  'makemetheking.com',
  'manybrain.com',
  'mbx.cc',
  'mega.zik.dj',
  'meinspamschutz.de',
  'meltmail.com',
  'messagebeamer.de',
  'mezimages.net',
  'mierdamail.com',
  'mintemail.com',
  'mjukglass.nu',
  'mobi.web.id',
  'moburl.com',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'monumentmail.com',
  'mt2009.com',
  'mt2014.com',
  'mycard.net.ua',
  'mycleaninbox.net',
  'myemailboxy.com',
  'mymail-in.net',
  'mymailoasis.com',
  'mynetstore.de',
  'mypacks.net',
  'mypartyclip.de',
  'myphantomemail.com',
  'mysamp.de',
  'mytempemail.com',
  'mytempmail.com',
  'mytrashmail.com',
  'nabuma.com',
  'neomailbox.com',
  'nepwk.com',
  'nervmich.net',
  'nervtmich.net',
  'netmails.com',
  'netmails.net',
  'netzidiot.de',
  'neverbox.com',
  'nice-4u.com',
  'nincsmail.com',
  'nincsmail.hu',
  'nnh.com',
  'no-spam.ws',
  'noblepioneer.com',
  'nomail.xl.cx',
  'nomail2me.com',
  'nomorespamemails.com',
  'nonspam.eu',
  'nonspammer.de',
  'noref.in',
  'nospam.ze.tc',
  'nospam4.us',
  'nospamfor.us',
  'nospammail.net',
  'nospamthanks.info',
  'notmailinator.com',
  'notsharingmy.info',
  'nowhere.org',
  'nowmymail.com',
  'nurfuerspam.de',
  'nus.edu.sg',
  'nwldx.com',
  'objectmail.com',
  'obobbo.com',
  'odnorazovoe.ru',
  'one-time.email',
  'onewaymail.com',
  'online.ms',
  'opayq.com',
  'ordinaryamerican.net',
  'otherinbox.com',
  'ovpn.to',
  'owlpic.com',
  'pancakemail.com',
  'paplease.com',
  'pcusers.otherinbox.com',
  'pjkh.com',
  'plexolan.de',
  'poczta.onet.pl',
  'politikerclub.de',
  'pooae.com',
  'pookmail.com',
  'privacy.net',
  'privatdemail.net',
  'proxymail.eu',
  'prtnx.com',
  'punkass.com',
  'putthisinyourspamdatabase.com',
  'pwrby.com',
  'qq.com',
  'quickinbox.com',
  'rcpt.at',
  'reallymymail.com',
  'realtyalerts.ca',
  'recode.me',
  'recursor.net',
  'regbypass.com',
  'regbypass.comsafe-mail.net',
  'rejectmail.com',
  'reliable-mail.com',
  'rhyta.com',
  'rklips.com',
  'rmqkr.net',
  'royal.net',
  'rppkn.com',
  'rtrtr.com',
  's0ny.net',
  'safe-mail.net',
  'safersignup.de',
  'safetymail.info',
  'safetypost.de',
  'sandelf.de',
  'saynotospams.com',
  'schafmail.de',
  'schrott-email.de',
  'secretemail.de',
  'secure-mail.biz',
  'selfdestructingmail.com',
  'selfdestructingmail.org',
  'sendspamhere.de',
  'sharklasers.com',
  'shieldedmail.com',
  'shieldemail.com',
  'shiftmail.com',
  'shitmail.me',
  'shitware.nl',
  'shmeriously.com',
  'shortmail.net',
  'sibmail.com',
  'sinnlos-mail.de',
  'siteposter.net',
  'skeefmail.com',
  'slaskpost.se',
  'smashmail.de',
  'smellfear.com',
  'snakemail.com',
  'sneakemail.com',
  'snkmail.com',
  'sofimail.com',
  'sofort-mail.de',
  'sogetthis.com',
  'soodonims.com',
  'spam.la',
  'spam.su',
  'spam4.me',
  'spamail.de',
  'spambob.com',
  'spambob.net',
  'spambob.org',
  'spambog.com',
  'spambog.de',
  'spambog.ru',
  'spambox.info',
  'spambox.irishspringtours.com',
  'spambox.us',
  'spamcannon.com',
  'spamcannon.net',
  'spamcon.org',
  'spamcorptastic.com',
  'spamcowboy.com',
  'spamcowboy.net',
  'spamcowboy.org',
  'spamday.com',
  'spamex.com',
  'spamfree24.com',
  'spamfree24.de',
  'spamfree24.eu',
  'spamfree24.net',
  'spamfree24.org',
  'spamgoes.com',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'spamherelots.com',
  'spamhereplease.com',
  'spamhole.com',
  'spami.spam.co.za',
  'spaminator.de',
  'spamkill.info',
  'spaml.com',
  'spaml.de',
  'spammotel.com',
  'spamobox.com',
  'spamoff.de',
  'spamslicer.com',
  'spamspot.com',
  'spamstack.net',
  'spamthis.co.uk',
  'spamthisplease.com',
  'spamtrail.com',
  'spamtroll.net',
  'speed.1s.fr',
  'spoofmail.de',
  'stuffmail.de',
  'super-auswahl.de',
  'supergreatmail.com',
  'supermailer.jp',
  'superrito.com',
  'superstachel.de',
  'suremail.info',
  'talkinator.com',
  'tapchicuoihoi.com',
  'teewars.org',
  'teleworm.com',
  'teleworm.us',
  'temp-mail.org',
  'temp-mail.ru',
  'tempalias.com',
  'tempe-mail.com',
  'tempemail.biz',
  'tempemail.com',
  'tempinbox.co.uk',
  'tempinbox.com',
  'tempmail.eu',
  'tempmail2.com',
  'tempmaildemo.com',
  'tempmailer.com',
  'tempmailer.de',
  'tempmailaddress.com',
  'tempthe.net',
  'thanksnospam.info',
  'thankyou2010.com',
  'thc.st',
  'thelimestones.com',
  'thisisnotmyrealemail.com',
  'thismail.net',
  'throwawayemailaddresses.com',
  'tilien.com',
  'tittbit.in',
  'tmail.ws',
  'tmailinator.com',
  'toiea.com',
  'toomail.biz',
  'topranklist.de',
  'tradermail.info',
  'trash-amil.com',
  'trash-mail.at',
  'trash-mail.com',
  'trash-mail.de',
  'trash2009.com',
  'trashdevil.com',
  'trashemail.de',
  'trashmail.at',
  'trashmail.com',
  'trashmail.de',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashmail.ws',
  'trashmailer.com',
  'trashymail.com',
  'trashymail.net',
  'trialmail.de',
  'trillianpro.com',
  'turual.com',
  'twinmail.de',
  'tyldd.com',
  'uggsrock.com',
  'umail.net',
  'upliftnow.com',
  'uplipht.com',
  'uroid.com',
  'us.af',
  'venompen.com',
  'veryrealemail.com',
  'viditag.com',
  'viewcastmedia.com',
  'viewcastmedia.net',
  'viewcastmedia.org',
  'vomoto.com',
  'vpn.st',
  'vsimcard.com',
  'vubby.com',
  'walala.org',
  'walkmail.net',
  'webemail.me',
  'webm4il.info',
  'weg-werf-email.de',
  'wegwerf-emails.de',
  'wegwerfadresse.de',
  'wegwerfemail.com',
  'wegwerfemail.de',
  'wegwerfmail.de',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'wetrainbayarea.com',
  'wetrainbayarea.org',
  'wh4f.org',
  'whatiaas.com',
  'whatpaas.com',
  'whopy.com',
  'willhackforfood.biz',
  'willselldrugs.com',
  'wuzup.net',
  'wuzupmail.net',
  'www.e4ward.com',
  'www.gishpuppy.com',
  'www.mailinator.com',
  'wwwnew.eu',
  'x.ip6.li',
  'xagloo.com',
  'xemaps.com',
  'xents.com',
  'xmaily.com',
  'xoxy.net',
  'yapped.net',
  'yeah.net',
  'yep.it',
  'yogamaven.com',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'youmailr.com',
  'yourdomain.com',
  'ypmail.webredirect.org',
  'yuurok.com',
  'zehnminutenmail.de',
  'zetmail.com',
  'zippymail.info',
  'zoaxe.com',
  'zoemail.net',
  'zoemail.org'
];

/**
 * Fonction utilitaire pour extraire le domaine d'une adresse email
 */
export const extractDomain = (email: string): string => {
  const domain = email.split('@')[1]?.toLowerCase().trim();
  return domain || '';
};

/**
 * Fonction utilitaire pour vérifier si un domaine est dans une liste
 */
export const isDomainInList = (domain: string, domainList: string[]): boolean => {
  return domainList.includes(domain.toLowerCase());
};

/**
 * Statistiques des listes (pour monitoring)
 */
export const EMAIL_DOMAIN_STATS = {
  personalDomains: PERSONAL_EMAIL_DOMAINS.length,
  disposableDomains: DISPOSABLE_EMAIL_DOMAINS.length,
  suspiciousDomains: SUSPICIOUS_EMAIL_DOMAINS.length,
  totalBlocked: PERSONAL_EMAIL_DOMAINS.length + DISPOSABLE_EMAIL_DOMAINS.length,
  lastUpdated: '2025-01-18'
} as const;